module.exports = __webpack_public_path__ + "static/media/icc.c9903f1c.jpg";